import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import api from '../../api';
/* actions */
import {
  getAllCategories,
  editCategories
} from '../../redux/actions/categories';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/category';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    _id: id || '',
    name: '',
    type: '',
    macroCategory: '',
    description: '',
    company: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const categories = useSelector(state => state.categories);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllCategories({ company }));
  }, [dispatch]);

  useEffect(() => {
    (async function () {
      try {
        const params = { _id: id };
        const { data } = await api().get('/api/categories', { params });
        if (data[0]) {
          const newData = {
            ...INITIAL_VALUES,
            ...data[0],
            macroCategory: data[0].macroCategory
              ? data[0].macroCategory._id
              : ''
          };
          setData(newData);
        }
      } catch (err) {
        console.error('Error: ', err);
      }
    })();
  }, []);

  const submit = () => {
    const newData = {
      ...data
    };
    dispatch(editCategories(newData, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {categories.editSuccess && (
        <AlertMsg type="success" msg="Categoria atualizada com sucesso" />
      )}
      {categories.errorContent &&
        !categories.errorContent.message.includes('400') &&
        categories.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização da categoria"
        />
      )}
      {categories.errorContent &&
        categories.errorContent.message.includes('400') &&
        categories.editError && (
        <AlertMsg
          type="danger"
          msg="Uma categoria com o nome informado já está cadastrada"
        />
      )}
      {!categories.editSuccess && !categories.editError && (
        <AlertMsg type="info" msg="Área atualização de categorias" />
      )}
      <FormHeader title="Atualizar Categoria" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.name}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            onChange={evt => handleChangeDefault(evt, data, setData)}
            value={data.description}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/categories" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
